import { joiResolver } from "@hookform/resolvers/joi";
import { Button, TextField } from "@mui/material";
import Joi from "joi";
import { get } from "lodash";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { addNewSubject } from "../../services/subjects";
import { setModalState } from "../../store/modal/modalSlice";
import BaseModal from "../BaseModal";

export default function AddSubject({ refetch }) {
  const dispatch = useDispatch();

  const { open: isOpen } = useSelector((state) =>
    get(state.modal, "modal.addSubject")
  );

  const schema = Joi.object({
    name: Joi.string().required(),
  });

  const defaultState = {
    name: "",
  };

  const { control, handleSubmit, reset } = useForm({
    defaultValues: defaultState,
    resolver: joiResolver(schema),
  });

  const { mutateAsync: addSubjectMutation } = useMutation(addNewSubject);

  const onSubmit = async (name) => {
    await addSubjectMutation(name, {
      onError: (error) => {
        toast.error(error.message);
      },
      onSuccess: (data) => {
        dispatch(
          setModalState({
            modal: "modal.addSubject",
            state: { open: false, refetch: true },
          })
        );
        reset();
      },
    });
  };

  const handleClose = () => {
    dispatch(
      setModalState({
        modal: "modal.addSubject",
        state: { open: false, refetch: false },
      })
    );
  };

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={handleClose}
      heading="Add New Subject"
      footerChildren={
        <Button onClick={handleSubmit(onSubmit)}>Add Subject</Button>
      }
    >
      <Controller
        name="name"
        control={control}
        render={({ field, fieldState }) => (
          <TextField
            label="Enter Subject Name"
            size="small"
            error={!!fieldState.error}
            {...field}
          />
        )}
      />
    </BaseModal>
  );
}
